// Converted from TSX to JS
// Removed Next.js specific reCAPTCHA hook. Add your own implementation later if needed.
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    // Placeholder token (implement reCAPTCHA or other anti-spam as needed)
    const token = null;
    const baseUrl = process.env.REACT_APP_SERVER_URL; // Define in .env
    try {
      const response = await fetch(`${baseUrl}/api/contacts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data: { name, email, message }, token }),
      });
      const data = await response.json();
      // eslint-disable-next-line no-console
      console.log(response.data);
      toast.success("Message sent successfully!", { position: "top-center" });
      setEmail("");
      setMessage("");
      setName("");
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      toast.error("Message failed to send.", { position: "top-center" });
    }
  }

  return (
    <div data-aos="zoom-in" className="contact-wrapper lp-container">
      <div
        data-aos="fade-down"
        className="contact-inner"
        style={{
          backgroundImage: "url(/couv2.svg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="contact-grid">
          <div data-aos="fade-right" className="contact-grid-left">
            <div className="start-now-header">
              <h2 className="start-now-title" style={{ color: "white" }}>
                Get in Touch
              </h2>
              <hr className="start-now-line" style={{ borderColor: "white" }} />
            </div>
            <p className="contact-lead" style={{ color: "#A5F5DF" }}>
              Cytailor reports are delivered through a curated network of
              professional firms across Europe. If you advise organizations on
              risk, finance or technology and want to integrate quantitative
              cyber risk into your services, share your details and we will
              arrange a partnership discussion.
            </p>
            {/* <img
              src="/teamwork.jpeg"
              alt="Teamwork"
              className="contact-image"
            /> */}
          </div>
          <div data-aos="fade-left" className="contact-form-card">
            {/* <h2 className="contact-form-title" className="contact-form-sub">Schedule a Free Consultation</h2> */}
            <h3 style={{ fontSize: "34px" }}>
              Join the CyTailor partner ecosystem.
            </h3>
            <form onSubmit={handleSubmit}>
              <label className="form-label" htmlFor="name">
                Your Name
              </label>
              <input
                id="name"
                type="text"
                className="form-control"
                placeholder="Enter Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <label className="form-label" htmlFor="email">
                Your email address
              </label>
              <input
                id="email"
                type="email"
                className="form-control"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <label className="form-label" htmlFor="message">
                Type your message here
              </label>
              <textarea
                id="message"
                className="form-textarea"
                placeholder="Enter your message"
                required
                rows={5}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button type="submit" className="form-submit">
                Request Partnership Call
              </button>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default ContactUs;
